import { Component, Inject, Input, OnInit, SkipSelf } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwContentSelectorTab
 * @module mw.components.contentStream
 *
 * @param {string} [name=''] - Name of the tab, used for active state management.
 * @description
 * `mw-content-selector-tab` is a component whose responsibility handle tab.
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-selector-tab name="tab1"> <some-new-component></some-new-component> </mw-content-selector-tab>
 * </hljs>
 */
@Component({
    selector: 'mw-content-selector-tab',
    template: `
        <div class="mw-content-selector-tab" ng-class="{active: $ctrl.isActiveTab()}">
            <div class="mw-content-selector-tab__content">
                <ng-transclude></ng-transclude>
            </div>
        </mw-content-stream-selector-tab>
    `,
    legacy: {
        transclude: true
    }
})

export class ContentSelectorTabComponent implements OnInit {
    @Input('@') name: string;

    constructor(@Inject('mwContentSelectorTabs') @SkipSelf() private tabsCtrl) {
        'ngInject';
    }

    ngOnInit() {}

    setActiveTab(): void{
        this.tabsCtrl.setActiveTab(this.name);
    }

    isActiveTab(): boolean {
        return this.tabsCtrl.isActiveTab(this.name);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/content-selector-tabs/content-selector-tab.ts